import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import React from "react";

export default function CreateFrenchPuzzlesConfirmDialog({ open, onClose, onConfirm }) {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Create French Puzzles</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Would you like to create French puzzles?
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    This action finds English puzzles that are in READY_TO_REVIEW state and don't have a French version created, and creates them all.
                </Typography>
                <Alert severity="info" sx={{ mt: 2 }}>
                    System creates the French version automatically 
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="primary"
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}
